import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { authSelectors } from 'redux/auth';
import { useTranslation } from 'react-i18next';
import Avatar from 'components/Avatar';
import Greeting from 'components/Greeting';
import Grid from 'components/Grid';
import { isMobile } from 'helpers';

const AuthenticatedGreeting = ({ showAvatar = true, subtitle, ...rest }) => {

  const { t } = useTranslation(['component']);
  const { firstName, lastName, avatar } = useSelector(authSelectors.getMeUser);

  return (
    <Grid container spacing={2} alignItems="center" justifyContent="space-between" wrap="nowrap" {...rest}>
      <Grid item>
        <Greeting
          greeting={t('authenticatedGreeting.greeting', { name: firstName })}
          subtitle={subtitle ?? t('authenticatedGreeting.greetingSubtitle')}
        />
      </Grid>
      {showAvatar && (
        <Grid item>
          <Avatar size={isMobile ? 38 : 56} src={avatar?.src} srcSet={avatar?.srcSet} firstName={firstName} lastName={lastName} />
        </Grid>
      )}
    </Grid>
  );
};

AuthenticatedGreeting.propTypes = {
  showAvatar: PropTypes.bool,
  subtitle: PropTypes.string,
};

export default AuthenticatedGreeting;
